// Copyright (c) 2025-2026 One Great World LLC. All rights reserved.

import './SlideStyles.css'

function TagSenseSlide() {
  return (
    <div className="slide-content feature-slide">
      <div className="feature-demo">
        <iframe width="100%"
            src="https://www.youtube.com/embed/xlPNHlEBuvk?autoplay=1&mute=0&loop=1&playlist=xlPNHlEBuvk"
            title="Tag Sense AI demo"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen></iframe>
      </div>

      <div className="feature-header">
        <div className="feature-category">Tag Sense AI</div>
        <h2 className="slide-title">Auto-tag your files with private, local AI</h2>
        <p className="slide-text">
          Tag Sense AI runs locally to analyze and suggest context-aware tags for your files.
          Keep your data private while enjoying powerful automatic tagging and search improvements.
        </p>
      </div>
    </div>
  )
}

export default TagSenseSlide
